import { NavLink } from 'react-router-dom';
import { useAuthStore } from '../../features/auth/store';

interface Item {
  to: string;
  label: string;
  roles?: readonly ('closer' | 'manager' | 'admin')[];
  /** Quando true, item visível apenas para platform admins. */
  platformAdminOnly?: boolean;
}

const ITEMS: readonly Item[] = [
  { to: '/', label: 'Home' },
  { to: '/search', label: 'Busca' },
  { to: '/summaries', label: 'Resumos' },
  {
    to: '/ranking',
    label: 'Ranking',
    roles: ['manager', 'admin'],
  },
  { to: '/approvals', label: 'Aprovações' },
  {
    to: '/admin/billing',
    label: 'Cobrança (admin)',
    platformAdminOnly: true,
  },
];

export function Sidebar() {
  const role = useAuthStore((s) => s.user?.role ?? 'closer');
  const isPlatformAdmin = useAuthStore((s) => s.user?.is_platform_admin ?? false);
  return (
    <nav className="dash-sidebar" aria-label="Navegação principal">
      <ul>
        {ITEMS.filter((it) => {
          if (it.platformAdminOnly === true && !isPlatformAdmin) return false;
          if (it.roles !== undefined && !it.roles.includes(role as 'closer' | 'manager' | 'admin'))
            return false;
          return true;
        }).map((it) => (
          <li key={it.to}>
            <NavLink
              to={it.to}
              end={it.to === '/'}
              className={({ isActive }) =>
                'dash-nav-link' + (isActive ? ' dash-nav-link--active' : '')
              }
            >
              {it.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
